import React from 'react';
import { AlertCircle } from 'lucide-react';

const FormInstructions = () => {
  return (
    <div className="mb-6 p-4 bg-blue-50 border-l-4 border-blue-500 rounded">
      <div className="flex items-start">
        <AlertCircle className="w-5 h-5 text-blue-600 mr-3 mt-0.5 flex-shrink-0" />
        <div>
          <h3 className="text-sm font-semibold text-blue-900 mb-1">📝 填写提示</h3>
          <p className="text-sm text-blue-800">
            所有字段请使用英文字母填写（除了标明中文填写的内容外）。中文地址、姓名等中文内容请转换为拼音或英文。
          </p>
        </div>
      </div>
    </div>
  );
};

export default FormInstructions;
